module.exports = __webpack_public_path__ + "img/jonathan-hernandez.jpg";